/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import StyledButton, { StyledButtonProps } from './StyledButton';

import styles from '../../../styles/buttons/submit-button.module.css';

function SubmitButton({ className = null, ...props }: StyledButtonProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <StyledButton
            type="submit"
            className={classNames([styles.container, themeClassName, className])}
            colored
            {...props}
        />
    );
}

export default SubmitButton;
